import { ReactElement, useEffect, useRef } from 'react';
import { SkipToMainContentButton } from './SkipToMainContent.styles';
import Typography from '@mui/material/Typography';

export const SkipToMainContent = (): ReactElement => {
  const headingLookup = useRef({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    cancel() {},
    init: async () => {
      try {
        const heading = await new Promise<HTMLHeadingElement>((resolve, reject) => {
          const main = document.body.querySelector('main');
          if (!main) {
            reject();
            return;
          }

          const element = main.querySelector('h1');

          if (element) {
            resolve(element);
          }
        });

        heading.setAttribute('tabindex', '-1');
        heading.focus();

        /**
         * For Reader it is important that the heading keeps
         * tabindex -1 until focus moved out, Otherwise reader
         * may not jump to the heading.
         */
        heading.addEventListener(
          'focusout',
          () => {
            heading.removeAttribute('tabindex');
          },
          { once: true }
        );
      } catch {}
    },
  });

  const handleFocus = () => {
    return headingLookup.current.init();
  };

  useEffect(() => headingLookup.current.cancel, []);

  return (
    <SkipToMainContentButton
      variant="contained"
      id="skip-to-main-content-button"
      onClick={handleFocus}
    >
      <Typography variant="btnText">Skip To Main Content</Typography>
    </SkipToMainContentButton>
  );
};
